import type { Simplify } from 'type-fest';

import type { ProjectComponent, ProjectType } from './common';

export enum FilterKeys {
  Sort = 'sort',
  Title = 'title',
  Type = 'type',
  IsPublic = 'isPublic',
  Labels = 'labels',
  LatestScan = 'latestScan',
  TeamId = 'teamId',
  LastRevisionWithin = 'lastRevisionWithin',
  Locators = 'locators',
  Url = 'url',
  Inventory = 'inventory',
}

type TitleFilter = {
  [FilterKeys.Title]?: string;
}

type TypeFilter = {
  [FilterKeys.Type]?: ProjectType[];
}

type IsPublicFilter = {
  [FilterKeys.IsPublic]?: boolean;
}

type LabelsFilter = {
  [FilterKeys.Labels]?: string[];
}

type LatestScanFilter = {
  [FilterKeys.LatestScan]?: number;
}

type TeamIdFilter = {
  [FilterKeys.TeamId]?: number[] | null;
}

type LastRevisionWithinFilter = {
  [FilterKeys.LastRevisionWithin]?: number;
}

// Filter projects by one or more locators (exact match).
type LocatorsFilter = {
  [FilterKeys.Locators]?: string[];
}

// Filter projects by URL (exact match).
type UrlFilter = {
  [FilterKeys.Url]?: string;
}

// Filter projects by available project components
type InventoryFilter = {
  [FilterKeys.Inventory]?: ProjectComponent[],
}

/**
 * Filters related to shared projects.
 */
type SharedProjectFilters = {
  /**
   * Includes shared projects if set to `true`, default to undefined.
   */
  includeSharedProjects?: boolean;

  /**
   * Only include shared projects if set to `true`, default to undefined.
   */
  onlyIncludeSharedProjects?: boolean;
}

// CommonFilters apply to both projects and release groups.
type CommonFilters = TeamIdFilter & TitleFilter & LatestScanFilter & IsPublicFilter & SharedProjectFilters;

export type ProjectsFilter = Simplify<
  & CommonFilters
  & TypeFilter
  & LabelsFilter
  & LocatorsFilter
  & LastRevisionWithinFilter
  & UrlFilter
  & InventoryFilter
>;

export type ReleaseGroupsFilter =
  CommonFilters;

export type AnyFilter =
  ProjectsFilter |
  ReleaseGroupsFilter;
